import { registerComponent, getStoreData } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-availability-pickup",
  class ProductAvailabilityPickup extends WYATTElement {
    constructor() {
      super();

      this.dataset.loading = "true";
      this.available = this.dataset.available === "true";
      this.savedStoreId = localStorage.getItem("pickup_store_id");
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.pickupMessageContainer = this.querySelector(
        "[data-product-availability='pickup-message']",
      );

      if (this.savedStoreId) {
        this.savedStore = getStoreData(this.savedStoreId);
        this.renderTemplateWithStore();
      } else {
        this.style.display = "none";
      }

      this.bindEvents();
    }

    bindEvents() {
      this.subscribe(
        window.WYATT.PubSub.events.updatePickupStore,
        this.handleUpdatePickupStore.bind(this),
      );
    }

    handleUpdatePickupStore(event) {
      this.savedStore = getStoreData(event.detail.storeID);
      this.renderTemplateWithStore();
    }

    async renderTemplateWithStore() {
      let availabilities;

      try {
        availabilities =
          await window.WYATT.storeAvailability.gettingAvailability(
            this.productId,
          );
      } catch (error) {
        this.remove();
        return;
      }

      const savedStoreAvailability = availabilities[this.variantId].find(
        (availability) =>
          availability.id.toString() === this.savedStore.location_id,
      );
      const quantityAvailable = savedStoreAvailability?.quantityAvailable;

      if (quantityAvailable > 0 && this.savedStore.offers_store_pickup) {
        this.dataset.available = "true";
        this.pickupMessageContainer.textContent =
          "Free pickup available at this store";
      } else {
        this.dataset.available = "false";
        this.pickupMessageContainer.textContent =
          "Pickup not available at this store";
      }
      this.dataset.loading = "false";
      this.style.display = "flex";
    }
  },
);
